(function () {
  function findUpsell(form) {
    var scope = form.closest('.product__info-container') || document;
    return scope.querySelector('.mg-upsell');
  }

  document.addEventListener(
    'click',
    function (event) {
      var submitBtn = event.target.closest('button[type="submit"]');
      if (!submitBtn) return;

      var form = submitBtn.form || submitBtn.closest('form[data-type="add-to-cart-form"]');
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

      if (form.dataset.mgUpsellHandled === 'true') {
        delete form.dataset.mgUpsellHandled;
        return;
      }

      var upsell = findUpsell(form);
      if (!upsell) return;

      var checked = upsell.querySelectorAll('[data-mg-upsell-checkbox]:checked');
      if (!checked.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var items = Array.prototype.map.call(checked, function (checkbox) {
        return { id: Number(checkbox.dataset.variantId), quantity: 1 };
      });

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var cartAddUrl = root.replace(/\/?$/, '/') + 'cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .catch(function (error) {
          console.error('mg-pdp-upsell: failed to add add-ons to cart', error);
        })
        .then(function () {
          form.dataset.mgUpsellHandled = 'true';
          submitBtn.click();
        });
    },
    true
  );
})();
